export const initialState = {
    values: [{}],
};

export const reducer = (state, action) => {
    switch (action.type) {
        case 'MEASUREMENTS_ADD':
            // only add unique dates
            if (state.values.filter((val) => val.date === action.date).length < 1) {
                return {
                    ...state,
                    values: [...state.values, { ...action }],
                };
            }
            return {
                ...state,
            };
        case 'MEASUREMENTS_REMOVE_DATE':
            return {
                ...state,
                values: state.values.filter((val) => action.date !== val.date),
            };
        case 'MEASUREMENTS_SET':
            return {
                ...state,
                ...action,
            };
        case 'MEASUREMENTS_RESET':
            return {
                ...state,
                values: [{}],
            };
        default:
            return state;
    }
};
